<script setup lang="ts">
/**
 * The two-column sign-in / sign-up page (#1933). Left, the form column: a small logo top-left, the form centred, a
 * footer at the bottom. Right, the splash: not shown below the `lg` (1024px) breakpoint, where the form column fills
 * the width.
 *
 * Slots: `logo` (defaults to the header's Z mark and the "Zero Human" system label, as the signed-in header draws
 * them), `form`, `footer` and `splash`. Every value is a theme token or a Tailwind scale step: the layout states no
 * colour, size or radius of its own.
 */
import mark from '../assets/mark.svg'
import ZhSystemLabel from './ZhSystemLabel.vue'
</script>

<template>
    <div class="flex min-h-svh w-full">
        <div class="flex min-w-0 flex-1 flex-col gap-8 p-6 lg:px-14 lg:py-10">
            <div data-testid="auth-logo" class="flex items-center gap-3">
                <slot name="logo">
                    <!-- The label beside it says the name, so the mark itself is not announced. -->
                    <img :src="mark" alt="" class="size-6 lg:size-7" />
                    <ZhSystemLabel as="span">Zero Human</ZhSystemLabel>
                </slot>
            </div>
            <main data-testid="auth-form" class="flex w-full max-w-100 flex-1 flex-col justify-center self-center">
                <slot name="form" />
            </main>
            <footer data-testid="auth-footer">
                <slot name="footer" />
            </footer>
        </div>
        <aside data-testid="auth-splash" class="hidden w-9/20 shrink-0 p-6 pl-0 lg:flex">
            <slot name="splash" />
        </aside>
    </div>
</template>
